// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"b1090459","382":"26cbd39f","453":"cf1abe1e","850":"509ffa7b"}[chunkId] + ".chunk.js";
};